import React from 'react';

import { isGoGameEnv } from 'App/constants';
import { useIsImpersonated, useLogout } from 'Auth';

import {
  ListItemIcon,
  ListItemText,
  Divider,
  List,
  ListItemButton,
  Typography,
  makeStyles,
  EditNotificationsIcon,
  LogoutIcon,
  SupervisorAccountIcon,
  // DARK_THEME_ID,
  // LIGHT_THEME_ID,
  // SYSTEM_THEME_ID,
  // useThemeSwitcher,
  // ToggleButton,
  // ToggleButtonGroup,
  // SettingsBrightnessIcon,
  // LightModeIcon,
  // DarkModeOutlinedIcon,
} from '@gogame/components';
import { useIsAllowed } from '@gogame/permissions';

const ALLOW_IMPERSONATE_USER_PERMISSION_ID = 20;

const useStyles = makeStyles(() => {
  return {
    list: {
      paddingTop: 0,
      height: '100%',
    },
    itemIcon: {
      minWidth: 56,
      marginLeft: 12,
    },
  };
});

const UserMenuList = ({ onOpenImpersonate, onOpenNotificationsSettings }) => {
  const logout = useLogout();
  const classes = useStyles();
  const impersonated = useIsImpersonated();
  const isAllowImpersonate =
    useIsAllowed()(ALLOW_IMPERSONATE_USER_PERMISSION_ID) || impersonated;
  // const { activeThemeId, setActiveThemeId } = useThemeSwitcher();
  // const handleChangeThemeMode = useCallback(
  //   (e, value) => {
  //     setActiveThemeId(value);
  //   },
  //   [setActiveThemeId]
  // );
  return (
    <React.Fragment>
      <List className={classes.list}>
        {isGoGameEnv ? (
          <>
            {isAllowImpersonate ? (
              <>
                <ListItemButton
                  onClick={onOpenImpersonate}
                  disableGutters={true}
                >
                  <ListItemIcon className={classes.itemIcon}>
                    <SupervisorAccountIcon color={'action'} />
                  </ListItemIcon>
                  <ListItemText
                    primary={<Typography>Impersonating</Typography>}
                  />
                </ListItemButton>
                <Divider />
              </>
            ) : null}
            <ListItemButton
              onClick={onOpenNotificationsSettings}
              disableGutters={true}
            >
              <ListItemIcon className={classes.itemIcon}>
                <EditNotificationsIcon color={'action'} />
              </ListItemIcon>
              <ListItemText
                primary={<Typography>Notifications settings</Typography>}
              />
            </ListItemButton>
            <Divider />
          </>
        ) : null}
        <ListItemButton onClick={logout} disableGutters={true}>
          <ListItemIcon className={classes.itemIcon}>
            <LogoutIcon color={'action'} />
          </ListItemIcon>
          <ListItemText primary={<Typography>Logout</Typography>} />
        </ListItemButton>
        <Divider />
      </List>
      {/*<div />*/}
      {/*<Grid*/}
      {/*  container*/}
      {/*  direction={'column'}*/}
      {/*  alignItems={'center'}*/}
      {/*  justifyContent={'flex-end'}*/}
      {/*  sx={{ pb: '8px' }}*/}
      {/*>*/}
      {/*  <Grid item sx={{ pb: '16px' }}>*/}
      {/*    <Typography variant={'caption'}>MODE</Typography>*/}
      {/*  </Grid>*/}
      {/*  <Grid item sx={{ pb: '16px' }}>*/}
      {/*    <ToggleButtonGroup*/}
      {/*      size={'small'}*/}
      {/*      color={'primary'}*/}
      {/*      aria-label={'Theme mode'}*/}
      {/*      exclusive={true}*/}
      {/*      value={activeThemeId}*/}
      {/*      onChange={handleChangeThemeMode}*/}
      {/*    >*/}
      {/*      <ToggleButton value={DARK_THEME_ID}>*/}
      {/*        <DarkModeOutlinedIcon sx={{ pr: '8px' }} />*/}
      {/*        <Typography sx={{ textTransform: 'none' }}>Dark</Typography>*/}
      {/*      </ToggleButton>*/}
      {/*      <ToggleButton value={SYSTEM_THEME_ID}>*/}
      {/*        <SettingsBrightnessIcon sx={{ pr: '8px' }} />*/}
      {/*        <Typography sx={{ textTransform: 'none' }}>System</Typography>*/}
      {/*      </ToggleButton>*/}
      {/*      <ToggleButton value={LIGHT_THEME_ID}>*/}
      {/*        <LightModeIcon sx={{ pr: '8px' }} />*/}
      {/*        <Typography sx={{ textTransform: 'none' }}>Light</Typography>*/}
      {/*      </ToggleButton>*/}
      {/*    </ToggleButtonGroup>*/}
      {/*  </Grid>*/}
      {/*</Grid>*/}
    </React.Fragment>
  );
};

export default UserMenuList;
